/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

/**
 * Rewrites the raw "Cannot find variant" cart error into a clearer message.
 *
 * That error means the variant isn't resolvable through the storefront cart
 * API, which happens when its product is a Draft (not published to any
 * sales channel). This is enforced server-side by Shopify and can't be
 * bypassed from the theme, in the editor or anywhere else, so this only
 * reformats the failure message instead of trying to make the add-to-cart
 * succeed.
 */
(() => {
  const DRAFT_VARIANT_ERROR_TEXT = 'cannot find variant';
  const ERROR_CONTAINER_SELECTOR = '[data-cart-errors-container], [data-cart-errors]';
  const REWRITTEN_ATTRIBUTE = 'data-vitrshop-rewritten';

  const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode);

  const getReplacementMessage = () => {
    const strings = window.theme && window.theme.strings;

    if (isDesignMode()) {
      return (strings && strings.draft_product_error) || 'This product is a draft: set it to Active to test adding it to the cart.';
    }

    return (strings && strings.product_unavailable_error) || 'This product is no longer available.';
  };

  const rewriteError = (errorBox) => {
    if (errorBox.hasAttribute(REWRITTEN_ATTRIBUTE)) {
      return;
    }

    const text = errorBox.textContent.trim().toLowerCase();

    if (!text.includes(DRAFT_VARIANT_ERROR_TEXT)) {
      return;
    }

    const closeButton = errorBox.querySelector('[data-close-error]');

    errorBox.setAttribute(REWRITTEN_ATTRIBUTE, 'true');
    errorBox.textContent = getReplacementMessage();

    if (closeButton) {
      errorBox.appendChild(closeButton);
    }
  };

  const scanContainer = (container) => {
    const errorBox = container.querySelector('[data-error]') || (container.matches('[data-error]') ? container : null);

    if (errorBox) {
      rewriteError(errorBox);
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        if (node.matches(ERROR_CONTAINER_SELECTOR) || node.matches('[data-error]')) {
          scanContainer(node);
        }

        node.querySelectorAll?.(`${ERROR_CONTAINER_SELECTOR}, [data-error]`).forEach(scanContainer);
      });
    });
  });

  observer.observe(document.body, {childList: true, subtree: true});

  document.querySelectorAll(ERROR_CONTAINER_SELECTOR).forEach(scanContainer);
})();
